module.exports = __webpack_public_path__ + "static/media/umich.a07902f9.png";